module.exports = __webpack_public_path__ + "fe7b9a792d36c6fed8fd976dd084940a.png";